import { EuiContextMenu, EuiFlexGroup, EuiFlexItem, EuiHeaderLink, EuiHeaderSectionItemButton, EuiPopover } from '@elastic/eui';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Flag from 'react-flagkit';
import { useLanguage } from '../../../../shared/hooks/Language';


export const SelectorIdioma = () =>{

    const {languages,onChnageLanguage,language} = useLanguage();

    let InitialLanguage = languages.filter((f)=> f.value===language)[0];

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [selected, setSelected] = useState(InitialLanguage);

    const onPopoverClick = () => setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);

    useEffect(()=>{
        const newLanguage = languages.filter((f)=> f.value===language)[0];
        setSelected(newLanguage);
    },[language])

    useEffect(()=> {if(selected!==undefined){setIsPopoverOpen(false)}},[selected])

    const getItems = [{
        id: 0,
        items: languages.map((l)=> { 
            return {
                key: `link-language-${l.label}`,
                name: <p>{l.label}</p>,
                icon: <Flag country={l.value} />,
                onClick: () => {onChnageLanguage(l.value)}
            }
        })
    }];

    const button = useCallback(() => selected && (
        <EuiHeaderSectionItemButton
          aria-expanded={isPopoverOpen}
          aria-haspopup="true"
          onClick={onPopoverClick}
          >
          <EuiHeaderLink key={'headerlink-languege'} className="languageButtonMenu">
            <EuiFlexGroup gutterSize='s'>
                <EuiFlexItem grow={false}><Flag country={selected.value}/></EuiFlexItem>
                <EuiFlexItem>{selected.label}</EuiFlexItem>
            </EuiFlexGroup>
          </EuiHeaderLink>
        </EuiHeaderSectionItemButton>
    )
    ,[isPopoverOpen,onPopoverClick,selected])

    return(
        <EuiPopover
		ownFocus={false}
		anchorPosition='downCenter'
		button={button()}
		isOpen={isPopoverOpen}
		closePopover={closePopover}
        panelStyle={{padding: "1px"}}
		initialFocus="[id=popover-languege-selection]">
            <EuiContextMenu initialPanelId={0} panels={getItems}/>
        </EuiPopover>
    )
}